// extracted by css-extract-rspack-plugin
export default {"ColumnGrid":"QazVN"};